export default __webpack_public_path__ + "static/media/highlight-10-new.238dd49c.jpg";